var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"week-days"},[_c('tr',{staticClass:"week-days"},_vm._l((_vm.weekdays),function(day){return _c('td',{key:day,staticClass:"week-days__day"},[_c('span',[_vm._v(_vm._s(day))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7a3edc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/WeekDays.vue
// module id = 573
// module chunks = 1